<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid"
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '../Mixins/Index'
import Permission from '@/mixins/Permission'
import TemplateIcone from './TemplateIcone'

import InputFormText from '@/components/form/InputForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
	},
	computed: {
		urlDataSource() {
			return `${this.$url}/v1/servicos?offset=8`
		}
	},
	watch: {
		'filtro.titulo' () {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'Serviços',
			titleNew: '',
			url: '/servicos/servicos/',
			columns: [{
				field: 'id',
				title: 'Id',
				width: 40
			}, {
				field: 'titulo',
				title: 'Título',
				width: 200
			}, {
				template: this.getTemplateIcone,
				title: 'Icone',
				width: 40,
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 50
			}],
			filtro: {
				titulo: null,
			},
			isActive: false,
		}
	},
	methods: {
		parse(d) {
			d.data.map(i => {
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.titulo,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/v1/servicos/${item.id}`, 'delete').catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		},
		getTemplateIcone(e) {
			return {
				template: TemplateIcone,
				templateArgs: {
					data: e
				}
			}
		},
	},
	created() {
		this.verifPermissao()
	}
}
</script>

<style lang="stylus">
</style>
